import { defineAsyncComponent } from 'vue';

export const LazyRulesPolicyDocument = defineAsyncComponent(
	() => import('./components/Policy/RulesPolicyDocument.vue'),
);
